export default "__VITE_ASSET__CARd9wbJ__";